import { render, staticRenderFns } from "./ontick-slider.component.vue?vue&type=template&id=2ba9fc88&scoped=true"
import script from "./ontick-slider.component.vue?vue&type=script&lang=js"
export * from "./ontick-slider.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-slider.component.vue?vue&type=style&index=0&id=2ba9fc88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba9fc88",
  null
  
)

export default component.exports